import React, { useEffect, useReducer, useRef, useState } from 'react';
import { FlatList, Pressable, StyleSheet, Text, View } from 'react-native';
import { getAvatarByItem2, getMsgContent, isGroupTopic, sendFail, sendSuc } from '../../utils/utils';
import { CSearchInput } from '../../components/CSearchInput';
import { MainNavProps } from "../navigation/main/MainParamList";
import { TopicWithSummary } from "../../../imsdk/api/topic";
import { useStore } from "../../store/UserStore";
import { CListItem } from "./CListItem";
import { color_333333, color_main } from "../../assets/style/colors";
import { CListItemSimple } from "../Contact/CListItemSimple";
import { ForwardConfirmModal } from "./ForwardConfirmModal";
import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { sendMsg } from "../../net/service";
import { SendMsgRequestData } from "../../net/request";
import { getEncrypt } from "../../store/token";
import { UserSchema } from "../../realm/contactSchema";
import { ChartMessageItem, MessageType, strToType } from "../../constants/types";
import time from "../../../imsdk/time";
import * as ImSdk from "../../../imsdk/api";
import { getLastSendMsg, setLastSendMsg } from "../../net/database";
import { showToast } from "../../components/Toast";
import {
    Str_CheckBox,
    Str_Confirm, Str_CreateNewChat,
    Str_Forward_document_warning,
    Str_Forward_image_warning,
    Str_Forward_video_warning,
    Str_Group_no_documents,
    Str_Group_no_images,
    Str_Group_no_videos,
    Str_GroupName,
    Str_InProhibition,
    Str_Radio,
    Str_Search,
    Str_SelectChat,
    Str_SendFail,
    Str_SpeakFrequently
} from "../../language/string_res";
import { upsetMsg, useChatStore } from "../../store/ChatStore";
import { CryptEngine } from "../../utils/CryptEngine";
import globalEventBus from '../../utils/EventBus';
import { Group } from '../../../imsdk/db/t_group';


export function ForwardChat({ navigation, route }: MainNavProps<'ForwardChat'>) {
    const { state, dispatch } = useStore();
    const { chatState } = useChatStore();
    const [search, setSearch] = useState('');
    const [modalVisible, setModalVisible] = useState(false);
    const [showCheck, setShowCheck] = useState(false);
    // 转发会话中的选中项
    const [selectItem, setSelectItem] = useState<TopicWithSummary[]>([])
    // 新的会话
    const [newChat, setNewChat] = useState<TopicWithSummary[]>([]);
    const im = ImSdk.getInstance();
    const currentUid: number = im.CurrentUid(); // 当前用户
    const msg = route.params.msg;
    const allTopics = [
        ...state?.topicSummaryList?.top ?? [],
        ...state?.topicSummaryList?.normal ?? [],
    ];
    const [topics, setTopics] = useState<TopicWithSummary[]>([]);
    useEffect(() => {
        if (search) {
            setTopics(
                allTopics.filter((v) => {
                    const topicName = v.topic?.name ?? '';
                    const groupName = v.group?.name ?? '';
                    const hay = `${topicName}\u0001${groupName}`;
                    return hay.indexOf(search) >= 0;
                }),
            );
        } else {
            setTopics(allTopics);
        }
    }, [search]);

    useEffect(() => {
        //新会话转发过来的联系人
        if (route.params && route.params.selectContact) {
            setModalVisible(true);
            setNewChat(() => route.params.selectContact);
        }
        return () => {
            setNewChat([]);
            updateAll([])
        };
    }, [route.params]);

    function changeHeaderStatus() {
        if (!showCheck) {
            setShowCheck(true);
            updateAll([])
        } else if (selectItem.length > 0) {
            setModalVisible(true);
        } else {
            setShowCheck(false);
        }
    }

    function updateAll(list: TopicWithSummary[]) {
        setSelectItem(list)
    }

    async function update(topic: TopicWithSummary): Promise<boolean> {
        const list = [...selectItem]
        const index = list.findIndex(
            (v) => v.topic.tid === topic.topic.tid,
        );
        if (index > -1) {
            list.splice(index, 1);
        } else {
            if (msg && topic.group) {
                const data = await funCanSend(topic.topic.tid, {
                    toTopidId: topic.topic.tid,
                    type: msg.type,
                    content: msg.content,
                    cid: msg.cid.toString(),
                    encrypt: msg.encrypt || 0,
                    meta: msg.meta,
                }, topic.group)
                if (!data.canSend) {
                    showToast(data.msg)
                    return false
                }
            }
            list.push(topic);
        }
        setSelectItem(list)
        return true
    }

    const handleItemPress = async (item: TopicWithSummary) => {
        console.log('当前tid, ', item.topic.tid);
        // if (
        //     selectItem.every(
        //         (selectItem: any) => selectItem.topic.tid !== item.topic.tid,
        //     )
        // ) {
        const can = await update(item)
        // }
        // 单选
        if (!showCheck && can) {

            setModalVisible(true);
        }
    };

    const ForwardItem = ({ item }: { item: TopicWithSummary }) => {
        // 过滤脏数据
        const left = getAvatarByItem2(item);
        return (
            <CListItem
                hasRadio={showCheck}
                id={item.topic.tid}
                left={left}
                isChecked={
                    selectItem.findIndex(
                        (v) => v.topic.tid === item.topic.tid,
                    ) > -1
                }
                item={item.topic}
                center={<Text numberOfLines={1} ellipsizeMode='tail' style={styles.title}>{item.topic.name ?? ""}</Text>}
                onClick={() => handleItemPress(item)}
            />
        );
    };

    // 转发消息
    const forwardMessage = (leaveMsg: string) => {
        setModalVisible(false);
        let selected: TopicWithSummary[] =
            newChat.length === 0 ? selectItem : newChat;
        const msgNeedSend: { msg: SendMsgRequestData, group?: Group }[] = [];
        let encrypt = getEncrypt()
        let cid = Date.now()
        selected.map((item, index) => {
            cid += index * 100;
            const common = {
                type: msg?.type || 'txt', // 这里的type是指消息类型
                // type: 'txt', // 这里的type是指消息类型
                cid: cid.toString(),
                encrypt: encrypt,
                meta: {} as any,
                toTopidId: item.topic.tid,
            };
            let leaveContent = leaveMsg
            if (encrypt === 1) {
                const content = CryptEngine.encode(encrypt, msg?.content || '', cid)
                leaveContent = CryptEngine.encode(encrypt, leaveContent, (cid + 100))
                msgNeedSend.push({
                    msg: { ...common, content: content, meta: msg?.meta },
                    group: item.group
                });
            } else {
                msgNeedSend.push({
                    msg: { ...common, content: msg?.content || '', meta: msg?.meta },
                    group: item.group
                });
            }
            if (leaveMsg) {
                msgNeedSend.push({
                    msg: {
                        ...common,
                        type: 'txt',
                        cid: (cid + 100).toString(),
                        content: leaveContent,
                    },
                    group: item.group
                });
            }
        });
        send(msgNeedSend);
    };

    // 消息发送
    async function send(msgNeedSend: { msg: SendMsgRequestData, group?: Group }[]) {
        const length = msgNeedSend.length
        if (length > 0) {
            for (let index = 0; index < length; index++) {
                const data = msgNeedSend[index];
                const item = data.msg
                const group = data.group

                const tid = item.toTopidId
                const isGroup = isGroupTopic(tid)
                if (isGroup) {
                    let isAdmin = false
                    let canSend = true;
                    let msg = ''

                    // ImSdk.getInstance().GetGroupDetail(tid).then((r) => {
                    if (group) {
                        // const group = r.group;
                        if (group?.adminUids) {
                            const curUid = im.CurrentUid();
                            if (curUid !== 0 && group.adminUids.includes(curUid)) {
                                isAdmin = true;
                            }
                        }
                        if (!isAdmin) {
                            const data = await funCanSend(tid, item, group)
                            canSend = data.canSend
                            msg = data.msg
                        }
                    }
                    if (canSend) {
                        sendMessage(item)
                        if (length - 1 === index) {
                            sendSucc()
                        }
                    } else {
                        showToast(msg)
                        return
                    }
                    // })
                } else {
                    sendMessage(item)
                    if (length - 1 === index) {
                        sendSucc()
                    }
                }
            }
        }
    }
    //用来判断当前回话是否能发送该消息
    async function funCanSend(tid: string, msg: SendMsgRequestData, group: Group): Promise<{ canSend: boolean, msg: string }> {
        let isAdmin = false
        // ImSdk.getInstance().GetGroupDetail(tid).then((r) => {
        // const group = r.group;
        if (group?.adminUids) {
            const curUid = im.CurrentUid();
            if (curUid !== 0 && group.adminUids.includes(curUid)) {
                isAdmin = true;
            }
        }
        if (isAdmin) {
            return { canSend: true, msg: "" }
        }
        let lastSendTime = 0;
        const lastSendMsg = await getLastSendMsg(group.uid, tid);
        if (lastSendMsg && lastSendMsg.length > 0) {
            lastSendTime = lastSendMsg[0].time;
        }
        //全体禁言
        if (group?.group_ban_chat === "1") {
            return { canSend: false, msg: `${group.name || Str_GroupName} ${Str_InProhibition}` }
        }
        if (group?.group_chat_interval_time) {
            //发言间隔时间校验
            const num = Number(group.group_chat_interval_time) * 1000;
            const nowTime = time.now().getTime();
            if (lastSendTime + num > nowTime) {
                return { canSend: false, msg: `${group.name || Str_GroupName} ${Str_SpeakFrequently}` }
            }
        }
        if (msg.type === MessageType.IMAGE && group?.group_member_image !== "1") {
            //禁止发送图片
            return { canSend: false, msg: Str_Group_no_images }
        }
        if (msg.type === MessageType.VIDEO && group?.group_member_video !== "1") {
            //禁止发送视频
            return { canSend: false, msg: Str_Group_no_videos }
        }
        if (msg.type === MessageType.DOCUMENT && group?.group_member_doc !== "1") {
            //禁止发送文件
            return { canSend: false, msg: Str_Group_no_documents }
        }
        if (msg.type === MessageType.TALK) {
            if (msg.content) {
                const content = CryptEngine.decode(msg.encrypt, msg.content, msg.cid)
                const { selectMessages }: { selectMessages: any[] } = JSON.parse(content)
                const len = selectMessages.length
                for (let i = 0; i < len; i++) {
                    const element = selectMessages[i]
                    if (element.type === MessageType.IMAGE && group?.group_member_image !== "1") {
                        //禁止发送图片
                        return { canSend: false, msg: Str_Forward_image_warning }
                    }
                    if (element.type === MessageType.VIDEO && group?.group_member_video !== "1") {
                        //禁止发送视频
                        return { canSend: false, msg: Str_Forward_video_warning }
                    }
                    if (element.type === MessageType.DOCUMENT && group?.group_member_doc !== "1") {
                        //禁止发送文件
                        return { canSend: false, msg: Str_Forward_document_warning }
                    }
                }
            }
        }
        return { canSend: true, msg: "" }
    }
    function sendSucc() {
        dispatch({ type: 'UPDATE_FORWARD_TIP_STATUS', payload: true });
        navigation.goBack();
    }


    function sendMessage(item: SendMsgRequestData) {
        let content = item.content;
        if (content) {
            let user: UserSchema = { uid: currentUid }
            if (state && state.user) {
                user = state?.user
            }
            let encrypt = getEncrypt()

            // 本地展示的需要解密
            if (encrypt === 1) {
                content = CryptEngine.decode(encrypt, content, item.cid)
            }
            const msg: ChartMessageItem = {
                tid: item.toTopidId,
                cid: Number(item.cid),
                type: strToType(item.type),
                content: content,
                atUids: item.atUids,
                meta: (item.meta || {}) as any,
                mid: '',
                encrypt: encrypt,
                sender: currentUid,
                send_statue: '0',
                user: user,
                stime: time.now().getTime()
            }
            const curCahtTid = chatState.curTopicWithSummary.topic.tid
            if (msg.tid === curCahtTid) {
                globalEventBus.emit('SEND_MSG', msg)
            }
            
            upsetMsg(msg).then()
            sendMsg(item).then(async (res) => {
                if (res.code !== 0) {
                    sendFail(msg, curCahtTid, res.msg)
                } else {
                    await sendSuc(msg)
                }
            }).catch(err => {
                sendFail(msg,curCahtTid, err.msg)
            })
        }
    }

    return (
        <BaseScreen>
            <NavBar showBack={true} title={Str_SelectChat} rightChildren={
                <Pressable onPress={changeHeaderStatus}>
                    <Text style={styles.headerRightText}>
                        {showCheck
                            ? selectItem.length > 0
                                ? `${Str_Confirm}(${selectItem.length})`
                                : Str_Radio
                            : Str_CheckBox}
                    </Text>
                </Pressable>} />
            <CSearchInput
                searchVal={search}
                onChange={setSearch}
                placeholder={Str_Search}
            />
            <View>
                <CListItemSimple
                    leftText={Str_CreateNewChat}
                    rightArrow={true}
                    handleClick={() =>
                        navigation.navigate('ForwardNewChat', {
                            from: 'Forward',
                            msg: msg
                        })
                    }
                />
            </View>
            <FlatList
                keyExtractor={(item: TopicWithSummary) => item.topic.tid}
                data={topics}
                keyboardDismissMode="on-drag"
                renderItem={({ item }) => {
                    return (
                        <View key={item.topic.tid}>
                            <ForwardItem item={item} />
                        </View>
                    );
                }}
            />
            <ForwardConfirmModal
                modalVisible={modalVisible}
                receivers={newChat.length > 0 ? newChat : selectItem}
                message={getMsgContent(msg!.type, msg!.content)}
                cancel={() => {
                    setNewChat([]);
                    updateAll([]);
                    setModalVisible(false);
                }}
                confirm={(leaveMsg: string) => forwardMessage(leaveMsg)}
            />
        </BaseScreen>
    );
}

const styles = StyleSheet.create({
    headerRightText: {
        color: color_main,
        fontSize: 16,
        marginRight: 10,
    },
    title: {
        fontSize: 16,
        color: color_333333,
    },
})